import React from 'react'
import './index.css'
export default () => {
	return (
		<div className="penguin-container">
			<div className="penguin-body" />
			<div className="penguin-body-right-inside" />
			<div className="penguin-body-left-inside" />
			<div className="penguin-right-wing" />
			<div className="penguin-left-wing" />
			<div className="penguin-right-eye" />
			<div className="penguin-left-eye" />
			<div className="penguin-nose" />
			<div className="penguin-left-foot" />
			<div className="penguin-right-foot" />
			<div className="shadow" />
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/Penguin/index.js